import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2em;
  background: ${({ theme }) => theme?.body || '#0d0f14'};
  color: ${({ theme }) => theme?.text || '#fff'};
  text-align: center;

  .error-icon {
    font-size: 3em;
    margin-bottom: 0.5em;
    opacity: 0.3;
  }

  h2 {
    font-size: 1.3em;
    font-weight: 600;
    margin: 0 0 0.5em;
    opacity: 0.9;
  }

  p {
    font-size: 0.9em;
    opacity: 0.5;
    max-width: 400px;
    line-height: 1.6;
    margin: 0 0 1.5em;
  }

  button {
    padding: 10px 24px;
    background: #10b981;
    color: #fff;
    border: none;
    border-radius: 12px;
    font-size: 0.9em;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #059669;
    }
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[ErrorBoundary]', error, errorInfo);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <div className="error-icon">⚠️</div>
          <h2>Algo deu errado</h2>
          <p>
            Ocorreu um erro inesperado. Tente recarregar a página.
            Se o problema persistir, entre em contato com o suporte.
          </p>
          <button onClick={this.handleReload}>
            Recarregar página
          </button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
